import {ActionDefaults} from './DefaultActions'

// <<<<<<<<<<<<<<<<<<<<<<<<<<<< Action Header >>>>>>>>>>>>>>>>>>>>>>>>>.
const ActionHeader = {
  key: 'settings',
  label: 'Actions',
}

// <<<<<<<<<<<<<<<<<<<<<<<<<<<< Status Header >>>>>>>>>>>>>>>>>>>>>>>>>.
const StatusHeader = {
  key: 'status',
  label: 'Status',
}

// <<<<<<<<<<<<<<<<<<<<<<<<<<<< Priority Header >>>>>>>>>>>>>>>>>>>>>>>>>.
const PriorityHeader = {key: 'priority', label: 'Priority'}

// <<<<<<<<<<<<<<<<<<<<<<<<<<<< Routes Headers >>>>>>>>>>>>>>>>>>>>>>>>>.
const userHeaders = [
  {key: 'redirectedTo', label: 'Id ', redirectedTo: '/users', secondaryKey: 'id'},
  {key: 'fullName', label: 'Name'},
  {key: 'email', label: 'Email Address'},
  {...StatusHeader},
  {...ActionHeader},
]
const patientHeaders = [
  {key: 'redirectedTo', label: 'Id ', redirectedTo: '/users', secondaryKey: 'id'},
  {key: 'fullName', label: 'Name'},
  {key: 'gender', label: 'Gender'},
  {key: 'phone_number', label: 'Mobile'},
  {key: 'email', label: 'Email Address'},
  {...PriorityHeader},
  {...StatusHeader},
  {...ActionHeader},
]
const deviceRequestHeaders = [
  {key: 'doctor_id', label: 'Doctor Id'},
  {key: 'num_of_devices', label: 'No.of Devices '},
  {key: 'status', label: 'Status'},
  {key: 'is_rental', label: 'Is Rental'},
  {...ActionHeader},
]
const deviceHeaders = [
  {key: 'name', label: 'Name'},
  {key: 'redirectedTo', label: 'IMEI', redirectedTo: '/devices', secondaryKey: 'IMEI'},
  {
    key: 'doctor_id',
    label: 'Dcotor',
    condition: (currentUser) => currentUser?.isSuperAdmin,
  },
  {key: 'patient_id', label: 'Patient'},
  {key: 'amount', label: 'Price'},
  {...ActionHeader},
]
const paymentHeaders = [
  {key: 'createdAt', label: 'Date'},
  {key: 'amount', label: 'Price($)'},
  {key: 'status', label: 'Status'},
]
// <<<<<<<<<<<<<<<<<<<<<<<<<<<< Fields Config for Device Addition (Super Admin) >>>>>>>>>>>>>>>>>>>>>>>>>.
const deviceFieldConfigsForSuperAdmin = [
  {type: 'text', name: 'name', placeholder: 'Enter Name'},
  {type: 'text', name: 'description', placeholder: 'Description'},
  {type: 'text', name: 'IMEI', placeholder: 'Enter IMEI'},
  {type: 'number', name: 'amount', placeholder: 'Enter Price'},
]

// <<<<<<<<<<<<<<<<<<<<<<<<<<<< ROUTES META >>>>>>>>>>>>>>>>>>>>>>>>>.
export const RoutesMetaForDoctors = {
  overView: {
    title: 'Dashboard',
    fetchLatestDataPath: '/telemetry-data/latest-data',
    fetchPathOfPatients: '/patients/assigned-to',
    fetchPathOfNurses: '/users/assigned-nurse',
    pathToFetchDetails: '/patients',
    pathToBlockUnBlock: '/patients',
    permissionToPost: 'patient:create',

    // custom redirection for patient
    columns: [
      {name: 'Date', key: 'createdAt'},
      {name: 'Patient', key: 'patient_name'},
      {name: 'BP Sys', key: 'blood_pressure_sys'},
      {name: 'BP Dia', key: 'blood_pressure_dia'},
      {name: 'Pulse', key: 'pulse'},
    ],

    actions: [
      ActionDefaults.delete,
      ActionDefaults.setThreshold,
      ActionDefaults.changePriority,
      ActionDefaults.edit,
      ActionDefaults.assignNurse,
      ActionDefaults.viewProfile,
      ActionDefaults.block,
      ActionDefaults.assignDevice,
    ],
  },
  patient: {
    title: 'Patients',
    fetchPath: '/patients',
    postPath: '/patients',
    pathToUpdate: '/patients',
    pathToFetchDetails: '/patients',
    pathToBlockUnBlock: '/patients',
    permissionToPost: 'patient:create',
    pathToDelete: '/patients',
    fieldsConfig: {
      step1: {
        description: 'Personal Information',
        fields: [
          {type: 'text', name: 'firstName', placeholder: 'First Name'},
          {type: 'text', name: 'lastName', placeholder: 'Last Name'},
        ],
      },
      step2: {
        description: 'Contact Information',
        fields: [
          {type: 'text', name: 'email', placeholder: 'Email Address'},
          {type: 'text', name: 'phone_number', placeholder: 'Phone Number'},
          {type: 'text', name: 'address', placeholder: 'Address#'},
        ],
      },
      step3: {
        description: 'Personal Information',
        fields: [
          {type: 'text', name: 'cnic', placeholder: 'CNIC'},
          {type: 'date', name: 'dob', placeholder: 'Date-of-birth'},
          {
            type: 'radio',
            name: 'gender',
            placeholder: 'Gender',
            options: [
              {value: 'male', label: 'Male'},
              {value: 'female', label: 'Female'},
              {value: 'other', label: 'Other'},
            ],
          },
        ],
      },
      step4: {
        description: 'Device Information',
        fields: [
          {
            type: 'select',
            name: 'device_IMEI',
            placeholder: 'Select from available devices',
            options: [
              {value: 'laptop', label: 'Laptop'},
              {value: 'tablet', label: 'Tablet'},
              {value: 'phone', label: 'Phone'},
            ],
          },
        ],
      },
    },
    fieldsConfigForThresholdForm: {
      step1: {
        description: 'Blood pressure Systolic',
        fields: [
          {type: 'number', name: 'blood_pressure_systolic_max', placeholder: 'Max'},
          {type: 'number', name: 'blood_pressure_systolic_min', placeholder: 'Min'},
        ],
      },
      step2: {
        description: 'Blood Pressure Diastolic ',
        fields: [
          {type: 'number', name: 'blood_pressure_diastolic_max', placeholder: 'Max'},
          {type: 'number', name: 'blood_pressure_diastolic_min', placeholder: 'Min'},
        ],
      },
      step3: {
        description: 'Heart Beat Rate ',
        fields: [
          {type: 'number', name: 'heart_beat_max', placeholder: 'Max'},
          {type: 'number', name: 'heart_beat_min', placeholder: 'Min'},
        ],
      },
    },
    // custom redirection for patient
    columns: patientHeaders.map((header, index) =>
      index === 0 ? {...header, redirectedTo: '/patient'} : header
    ),
    DetailPageTables: [
      {
        tableName: 'Health',
        urlToFetchTableData: '/telemetry-data/history',
        isParamIncluded: true,
        isNdaysFilterParamIncluded: true,
        tableColumns: [
          {label: 'Date', valueFrom: 'createdAt'},
          {label: 'Time', valueFrom: 'createdAt'},
          {label: 'BP Sys', valueFrom: 'blood_pressure_sys'},
          {label: 'BP Dia', valueFrom: 'blood_pressure_dia'},
          {label: 'Pulse', valueFrom: 'pulse'},
        ],
      },
      {
        tableName: 'Time Tracked ',
        urlToFetchTableData: '/time-tracked/patient',
        isParamIncluded: true,
        isNdaysFilterParamIncluded: true,
        tableColumns: [
          {label: 'Description', valueFrom: 'description'},
          {label: 'From', valueFrom: 'from'},
          {label: 'To', valueFrom: 'to'},
          {label: 'Tracked', valueFrom: 'time_spent'},
          {label: 'Tracked By', valueFrom: 'tracker_name'},
        ],
      },
    ],
    actions: [
      ActionDefaults.viewProfile,
      // ActionDefaults.changePriority,
      // ActionDefaults.assignNurse,
      // ActionDefaults.assignDevice,
      ActionDefaults.delete,
      // ActionDefaults.setThreshold,
      // ActionDefaults.edit,
      // ActionDefaults.block,
    ],
  },
  nurse: {
    title: 'Nurses',
    fetchPath: '/users?role=nurse',
    postPath: '/users?role=nurse',
    pathToUpdate: '/users',
    pathToFetchDetails: '/users',
    pathToBlockUnBlock: '/users',
    fieldsConfig: [
      {type: 'text', name: 'firstName', placeholder: 'First Name'},
      {type: 'text', name: 'lastName', placeholder: 'Last Name'},
      {type: 'email', name: 'email', placeholder: 'Email'},
    ],
    columns: userHeaders.map((header, index) =>
      index === 0 ? {...header, redirectedTo: '/staff'} : header
    ),
    DetailPageTables: [
      {
        tableName: 'Patients',
        urlToFetchTableData: 'users/allocated_patients',
        isParamIncluded: true,
        tableColumns: [
          {label: 'Name', valueFrom: 'first_name'},
          {label: 'Email', valueFrom: 'email'},
          {label: 'Phone', valueFrom: 'phoneNumber'},
        ],
        valueFromSpecificObject: 'AssignedPatients',
      },
      {
        tableName: 'Time Tracked ',
        urlToFetchTableData: '/devices',
      },
    ],
    actions: [
      // because we don't have implemented functionality for emailverificatio thus hiding this resendemail action for now
      ActionDefaults.resendEmailToStaff,
      ActionDefaults.delete,
      ActionDefaults.cancelInvite,
      // ActionDefaults.edit,
      // ActionDefaults.assignNurse,
      // ActionDefaults.viewProfile,
      // ActionDefaults.block,
    ],
  },
  devices: {
    title: 'Devices',
    fetchPath: '/devices',
    postPath: '/device-request',
    pathToUpdate: '/devices',
    pathToFetchDetails: '/devices',
    ButtonText: 'Request Devices',
    fieldsConfig: [
      {
        type: 'number',
        name: 'num_of_devices',
        placeholder: 'No. of Devices',
        transform: (value) => Number(value),
      },
      {
        type: 'text',
        name: 'is_rental',
        placeholder: 'Is Rental ?',
        transform: (value) => value.toLowerCase() === 'true',
      },
    ],
    columns: [...deviceHeaders],
    DetailPageTables: [
      {
        tableName: 'Assign To',
        urlToFetchTableData: '/users?role=nurses',
      },
      {
        tableName: 'Previously Assigned',
        urlToFetchTableData: '/devices',
      },
    ],
    actions: [
      ActionDefaults.VIEW_DEVICE_INFO,
      ActionDefaults.ASSIGN_DEVICE_TO_PATIENT,
      ActionDefaults.UNASSIGN_DEVICE_FROM_PATIENT,
    ],
  },
  paymentHistory: {
    title: 'Payments',
    fetchPath: '/payment-history/doctor',
    postPath: '/payment-history',
    pathToUpdate: '/payment-history',
    pathToFetchDetails: '/payment-history',
    ButtonText: '',
    fieldsConfig: [
      {
        type: 'number',
        name: 'num_of_devices',
        placeholder: 'No. of Devices',
        transform: (value) => Number(value),
      },
      {
        type: 'text',
        name: 'is_rental',
        placeholder: 'Is Rental ?',
        transform: (value) => value.toLowerCase() === 'true',
      },
    ],
    columns: [...paymentHeaders],
    // DetailPageTables: [
    //   {
    //     tableName: 'Assign To',
    //     urlToFetchTableData: '/users?role=nurses',
    //   },
    //   {
    //     tableName: 'Previously Assigned',
    //     urlToFetchTableData: '/devices',
    //   },
    // ],
  },
}

// Update the RoutesMetaForDoctors with the new fieldsConfig for the devices object
const updatedRoutesMetaOfDoctorsForSuperAdmin = {
  ...RoutesMetaForDoctors, // Spread the existing structure
  devices: {
    ...RoutesMetaForDoctors.devices, // Spread the existing devices object
    fieldsConfig: deviceFieldConfigsForSuperAdmin,
    postPath: '/devices', // Replace the fieldsConfig with the new array
    ButtonText: '',
  },
}

export const RoutesMetaForSuperAdmin = {
  ...updatedRoutesMetaOfDoctorsForSuperAdmin, // Spread common metadata at the root level
  users: {
    title: 'Users',
    fetchPath: '/users',
    postPath: '/users?role=',
    pathToUpdate: '/users',
    pathToFetchDetails: '/users',
    fieldsConfig: [
      {type: 'text', name: 'firstName', placeholder: 'First Name'},
      {type: 'text', name: 'lastName', placeholder: 'Last Name'},
      {type: 'email', name: 'email', placeholder: 'Email'},
      {type: 'text', name: 'address', placeholder: 'Enter Address'},
    ],
  },
  doctor: {
    title: 'Doctors',
    fetchPath: '/users?role=doctor',
    postPath: '/users?role=doctor',
    pathToUpdate: '/users',
    pathToFetchDetails: '/users',
    pathToBlockUnBlock: '/users',
    fieldsConfig: [
      {type: 'text', name: 'firstName', placeholder: 'First Name'},
      {type: 'text', name: 'lastName', placeholder: 'Last Name'},
      {type: 'email', name: 'email', placeholder: 'Email'},
    ],
    columns: userHeaders.map((header, index) =>
      index === 0 ? {...header, redirectedTo: '/doctor'} : header
    ),
    DetailPageTables: [
      {
        tableName: 'Nurses',
        urlToFetchTableData: '/users/assigned-nurse',
        isParamIncluded: true,
        tableColumns: [
          {label: 'Name', valueFrom: 'fullName'},
          {label: 'Email', valueFrom: 'email'},
          {label: 'Phone', valueFrom: 'phoneNumber'},
        ],
      },
      {
        tableName: 'Patients',
        urlToFetchTableData: '/users/assigned-patient',
        isParamIncluded: true,
        tableColumns: [
          {label: 'Name', valueFrom: 'fullName'},
          {label: 'Email', valueFrom: 'email'},
          {label: 'Phone', valueFrom: 'phoneNumber'},
        ],
      },
      {
        tableName: 'Devices',
        urlToFetchTableData: '/devices/assigned-to',
        isParamIncluded: true,
        tableColumns: [
          {label: 'Name', valueFrom: 'name'},
          {label: 'IMEI', valueFrom: 'IMEI'},
        ],
      },
    ],
  },
  deviceRequest: {
    title: 'Device Requests',
    fetchPath: '/device-request',
    postPath: '/device-request',
    pathToUpdate: '/device-request',
    pathToFetchDetails: '/device-request',
    pathToDelete: '/device-request',
    pathToAssign: '/device-request/assign-devices',
    fieldsConfig: [
      {type: 'text', name: 'firstName', placeholder: 'First Name'},
      {type: 'text', name: 'lastName', placeholder: 'Last Name'},
      {type: 'email', name: 'email', placeholder: 'Email'},
    ],
    columns: deviceRequestHeaders.map((header, index) =>
      index === 0 ? {...header, redirectedTo: '/doctor'} : header
    ),
    actions: [ActionDefaults.delete, ActionDefaults.assignNurse, ActionDefaults.block],
    DetailPageTables: [
      {
        tableName: 'Nurses',
        urlToFetchTableData: '/users/assigned-nurse',
        isParamIncluded: true,
        tableColumns: [
          {label: 'Name', valueFrom: 'fullName'},
          {label: 'Email', valueFrom: 'email'},
          {label: 'Phone', valueFrom: 'phoneNumber'},
        ],
      },
      {
        tableName: 'Patients',
        urlToFetchTableData: '/users/assigned-patient',
        isParamIncluded: true,
        tableColumns: [
          {label: 'Name', valueFrom: 'fullName'},
          {label: 'Email', valueFrom: 'email'},
          {label: 'Phone', valueFrom: 'phoneNumber'},
        ],
      },
      {
        tableName: 'Devices',
        urlToFetchTableData: '/devices/assigned-to',
        isParamIncluded: true,
        tableColumns: [
          {label: 'Name', valueFrom: 'name'},
          {label: 'IMEI', valueFrom: 'IMEI'},
        ],
      },
    ],
  },
}
